import { render, staticRenderFns } from "./Accordion.vue?vue&type=template&id=7cf47ace&scoped=true&"
import script from "./Accordion.vue?vue&type=script&lang=js&"
export * from "./Accordion.vue?vue&type=script&lang=js&"
function injectStyles (context) {
  
  var style0 = require("./Accordion.vue?vue&type=style&index=0&id=7cf47ace&lang=scss&scoped=true&")
if (style0.__inject__) style0.__inject__(context)

}

/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "7cf47ace",
  null
  ,true
)

export default component.exports